import { storyblokEditable } from "@storyblok/react";
import { RenderRichtext } from "../RenderRichtext";
import { TextStoryblok } from "@/types/sb-component-types";
interface RichTextProps {
  blok: TextStoryblok;
}
export default function RichtText({
  blok
}: RichTextProps) {
  return <div {...storyblokEditable(blok)} data-sentry-component="RichtText" data-sentry-source-file="Text.tsx">
      <RenderRichtext content={blok.richtext} proseSize="sm" data-sentry-element="RenderRichtext" data-sentry-source-file="Text.tsx" />
    </div>;
}